/**
 * @generated SignedSource<<dd85b356198bb7d6ba27cd2914631b4b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamUrgentSignals_team$data = {
  readonly store: {
    readonly activeSignalCount: number;
    readonly hasHighPrioritySignals: boolean;
    readonly unreadSignalCount: number;
  };
  readonly urgentSignals: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"SignalListItem_signal">;
  }>;
  readonly " $fragmentType": "TeamUrgentSignals_team";
};
export type TeamUrgentSignals_team$key = {
  readonly " $data"?: TeamUrgentSignals_team$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamUrgentSignals_team">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamUrgentSignals_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Store",
      "kind": "LinkedField",
      "name": "store",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "activeSignalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasHighPrioritySignals",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unreadSignalCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Signal",
      "kind": "LinkedField",
      "name": "urgentSignals",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SignalListItem_signal"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node as any).hash = "5f6b9f3a4c667374209a33f1dc7accd1";

export default node;
